import { Box, Modal, ModalProps, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { IModalProps } from './props';

interface ModalSigningEDSProps {
  open: boolean;
}




export const SuccessIdentModal = ({open, handleClose}:IModalProps) => {

    useEffect(()=>{const timer = setTimeout(()=>{handleClose()},2000)},[])

    const modalBoxStyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '4px',
        width: '348px',
        height: '300px',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        padding: '48px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',

        '& h2': {
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: '700',
            color: '#3E3E3E',
        },
    };

    const SuccessIcon = (props: any) => (
        <svg
        xmlns='http://www.w3.org/2000/svg'
        width='94'
        height='94'
        viewBox='0 0 95 94'
        fill='none'
        {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M47.1042 94C73.0616 94 94.1042 72.9574 94.1042 47C94.1042 21.0426 73.0616 0 47.1042 0C21.1469 0 0.104248 21.0426 0.104248 47C0.104248 72.9574 21.1469 94 47.1042 94ZM73.3781 38.0239C75.7213 35.6807 75.7213 31.8818 73.3781 29.5386C71.035 27.1955 67.236 27.1955 64.8929 29.5386L42.3308 52.1007L30.05 39.8199C27.7069 37.4767 23.9079 37.4767 21.5647 39.8199C19.2216 42.163 19.2216 45.962 21.5647 48.3051L38.0882 64.8286L42.3308 69.0712L46.5735 64.8286L73.3781 38.0239Z'
                fill='#33C441'
            />
        </svg>
    )


    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='modal-title'
            aria-describedby='modal-description'>
            <Box sx={modalBoxStyle}>
                <Typography
                    id='modal-modal-title'
                    variant='h6'
                    component='h2'>
                    Личность водителя<br/>
                    успешно подтверждена!
                </Typography>
                <SuccessIcon />
            </Box>
        </Modal>
    );
}
